import { AlertDangerIcon, Caption, css, theme } from 'canoe';
import React from 'react';
import styled from 'styled-components';

const ErrorMessage = styled(Caption)<{ justify?: string }>`
  ${({ justify }) => css`
    display: flex;
    justify-content: ${justify === 'end' ? 'flex-end' : 'flex-start'};
    align-items: center;
    color: ${theme.colors.ParadiseRedD10};
  `}
`;

const StyledText = styled.div`
  padding-left: 4px;
`;

interface ToolboxErrorMessageProps {
  message: string;
  justify?: 'start' | 'end';
}

export const ToolboxErrorMessage = ({ message, justify }: ToolboxErrorMessageProps) => (
  <ErrorMessage className="toolbox-error-message" element="span" justify={justify}>
    <AlertDangerIcon size="s" color="ParadiseRedD10" />
    <StyledText>{message}</StyledText>
  </ErrorMessage>
);
